<template>
  <div>
    <div class="mt-4 mb-4">
      <!--Banque modal -->
      <b-modal
        id="modal-banque"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
        :title="titleModalBanque"
      >
        <template #default>
          <alert-error
            v-if="formBanque.errors.get('message')"
            :form="formBanque"
            :message="formBanque.errors.get('message')"
          ></alert-error>
          <form
            @submit.prevent="submitBanque"
            @keydown="formBanque.onKeydown($event)"
          >
            <div class="row pt-3">
              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_nom_compte_bancaire"
                    >Nom du compte bancaire
                    <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has(
                        'nom_compte_bancaire'
                      ),
                    }"
                    id="banque_nom_compte_bancaire"
                    v-model="formBanque.nom_compte_bancaire"
                    type="text"
                    placeholder="Nom du compte bancaire"
                    maxlength="50"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error
                    :form="formBanque"
                    field="nom_compte_bancaire"
                  ></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="'banque_banque"
                    >Banque <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has('banque'),
                    }"
                    id="banque_banque"
                    v-model="formBanque.banque"
                    type="text"
                    placeholder="Banque"
                    maxlength="30"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error :form="formBanque" field="banque"></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_num_compte"
                    >Numéro de compte <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has('num_compte'),
                    }"
                    id="banque_num_compte"
                    v-model="formBanque.num_compte"
                    type="text"
                    placeholder="Numéro de compte"
                    maxlength="50"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error :form="formBanque" field="num_compte"></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_iban"
                    >IBAN <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has('iban'),
                    }"
                    id="banque_iban"
                    v-model="formBanque.iban"
                    type="text"
                    placeholder="IBAN"
                    maxlength="5"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error :form="formBanque" field="iban"></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_bic"
                    >BIC <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has('bic'),
                    }"
                    id="banque_bic"
                    v-model="formBanque.bic"
                    type="text"
                    placeholder="BIC"
                    maxlength="15"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error :form="formBanque" field="bic"></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_domiciliation_compte"
                    >Domiciliation du compte <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has(
                        'domiciliation_compte'
                      ),
                    }"
                    id="banque_domiciliation_compte"
                    v-model="formBanque.domiciliation_compte"
                    type="text"
                    placeholder="Domiciliation du compte"
                    maxlength="100"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error
                    :form="formBanque"
                    field="domiciliation_compte"
                  ></has-error>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_proprietaire_compte"
                    >Propriétaire du compte <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has(
                        'proprietaire_compte'
                      ),
                    }"
                    id="banque_proprietaire_compte"
                    v-model="formBanque.proprietaire_compte"
                    type="text"
                    placeholder="Propriétaire du compte"
                    maxlength="100"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error
                    :form="formBanque"
                    field="proprietaire_compte"
                  ></has-error>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mt-n4">
                <div class="form-group">
                  <label for="banque_adresse_proprietaire"
                    >Adresse du propriétaire <span class="text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    :class="{
                      'is-invalid': formBanque.errors.has(
                        'adresse_proprietaire'
                      ),
                    }"
                    id="banque_adresse_proprietaire"
                    v-model="formBanque.adresse_proprietaire"
                    type="text"
                    placeholder="Adresse du propriétaire"
                    maxlength="100"
                    :required="modeBanque !== 'show'"
                    :disabled="modeBanque === 'show'"
                  />
                  <has-error
                    :form="formBanque"
                    field="adresse_proprietaire"
                  ></has-error>
                </div>
              </div>
            </div>
          </form>
        </template>
        <template #modal-footer>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="$bvModal.hide('modal-banque')"
          >
            Fermer
          </button>

          <button
            v-if="modeBanque !== 'show'"
            type="submit"
            class="btn btn-custom-primary w-40"
            @click="submitBanque"
            style="min-width: 100px"
          >
            {{ modeBanque === 'create' ? 'Créer' : 'Enregistrer' }}
          </button>
        </template>
      </b-modal>

      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="showBanqueModal(null)"
              >
                <i class="fas fa-plus"></i>
                Nouveau compte bancaire
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionBanque"
                v-show="isSelectBanque"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <BanqueDataTable
                ref="datatableBanque"
                @onSelect="onSelectBanqueRows"
                @onRowShow="showBanqueModal"
                @onRowEdit="editBanqueModal"
                @onRowsDelete="deleteBanqueRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/tiers_contact/tiers';
import BanqueDataTable from './DataTable.vue';

import From from 'vform';
export default {
  data() {
    return {
      formBanque: new From({
        nom_compte_bancaire: '',
        iban: '',
        bic: '',
        domiciliation_compte: '',
        proprietaire_compte: '',
        adresse_proprietaire: '',
        tiers: '',
        banque: '',
        num_compte: '',
      }),
      currentTiers: '',

      modeBanque: 'create',
      titleModalBanque: 'Ajout de nouveau compte bancaire',
      isSelectBanque: false,
    };
  },
  components: {
    BanqueDataTable,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    /**
     * Modal banque
     */
    async showBanqueModal(id) {
      if (id) {
        this.titleModalBanque = "Aperçu d'un compte bancaire";
        this.formBanque.reset();
        this.formBanque.clear();
        this.modeBanque = 'show';

        await window.axios
          .get(URL.BANQUE + '/' + id)
          .then((resp) => {
            Object.assign(this.formBanque, resp.data.tiersCompteBancaire);
          })
          .catch();
      } else {
        this.modeBanque = 'create';
        this.titleModalBanque = 'Ajout de nouveau compte bancaire';
        this.formBanque.reset();
        this.formBanque.clear();
      }

      await this.$bvModal.show('modal-banque');
    },
    async editBanqueModal(id) {
      this.titleModalBanque = "Edition d'un compte bancaire";
      this.formBanque.reset();
      this.formBanque.clear();
      this.modeBanque = 'edit';

      await window.axios
        .get(URL.BANQUE + '/' + id)
        .then((resp) => {
          Object.assign(this.formBanque, resp.data.tiersCompteBancaire);
        })
        .catch();

      await this.$bvModal.show('modal-banque');
    },
    submitBanque() {
      this.formBanque.tiers = this.currentTiers.uuid;
      this.$bvModal.hide('modal-banque');
      if (this.formBanque.id) {
        //update
        this.formBanque
          .put(URL.BANQUE + '/' + this.formBanque.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formBanque.reset();
            this.formBanque.clear();
            this.$refs.datatableBanque.loadItems();
          })
          .catch((err) => {
            this.formBanque.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-banque');
          });
      } else {
        //store
        this.formBanque
          .post(URL.BANQUE)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formBanque.reset();
            this.formBanque.clear();
            this.$refs.datatableBanque.loadItems();
          })
          .catch((err) => {
            this.formBanque.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-banque');
          });
      }
    },
    onSelectBanqueRows(isSelectBanque) {
      this.isSelectBanque = isSelectBanque;
    },
    deleteAllSelectionBanque() {
      this.deleteBanqueRows(this.$refs.datatableBanque.idsRowsSelected);
    },
    deleteBanqueRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.BANQUE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableBanque.loadItems();
                this.isSelectBanque = false;
              })
              .catch();
          }
        });
      }
    },

    init() {
      let id = this.$route.params.id;
      window.axios
        .get(URL.TIERS + '/' + id)
        .then((resp) => {
          this.currentTiers = resp.data.tiers;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
